module.exports = __webpack_public_path__ + "static/03-557be2c4f1ad5267b00a55a0d61f745d.jpg";